import React, { Component } from "react";
import "../containers/MainAppContainer.css";
import { translations } from "../containers/assets/translations";
import { ControlLabel, Col, FormGroup, FormControl } from "react-bootstrap";
import Checkbox from "@material-ui/core/Checkbox";

export default class ReservationDetails extends Component {
  render() {
    let lang = this.props.lang;
    return (
      <div>
        {this.props.displayReservationResults ? (
          <Col>
            <div className="col-md-12 headTicks">
              <div className="col-md-1 selectCol">
                Select All
                <Checkbox
                  className="checkboxnonShow"
                  color="primary"
                  checked={this.props.isPersonSelectAllToggled}
                  onClick={() => {
                    this.props.handlePersonSelectAllButton();
                    this.props.handleVehicleSelectAllButton();
                  }}
                />
              </div>
              <div className="col-md-2 toResp">
                {translations[lang]["Ticket Number"]}
              </div>
              <div className="col-md-1 toResp">
                {"Board ID"}
              </div>
              <div className="col-md-3 toResp">
                {translations[lang]["Surname Name"]}
              </div>
              <div className="col-md-1 toResp">
                {translations[lang]["Age/Cat Gender"]}
              </div>
              <div className="col-md-1 toResp">
                {translations[lang]["Nationality"]}
              </div>
              <div className="col-md-2 toResp">
                {translations[lang]["Birth Date - Place"]}
              </div>

              <div className="col-md-1 toResp">{translations[lang]["Status"]}</div>
            </div>
            <div className="scrollbar2 style-1">
              {this.props.personTickets.map((personTickets, index) => {
                return (
                  <div
                    ref={this.props.myRef}
                    className="col-md-12 col-xs-12 resultsRTicks"
                    key={personTickets.BookID}
                  >
                    <div className="col-md-1 col-xs-1 selectCol">
                      <Checkbox
                        color="primary"
                        checked={this.props.selectedPersonTickets[index]}
                        onClick={() => {
                          this.props.handlePersonCheckboxChange(index);
                        }}
                      />
                    </div>

                    <div className="col-md-2 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {translations[lang]["Ticket Number"]}:
                      </span>
                      {personTickets.TicketNumber}
                    </div>
                    <div className="col-md-1 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {"Board ID"}:
                      </span>
                      {personTickets.BoardID === "0" ? ("-") : (personTickets.BoardID)}
                    </div>
                    <div className="col-md-3 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {translations[lang]["Surname Name"]}:
                      </span>
                      {personTickets.Surname} {personTickets.Name}
                      {this.props.isMRZMandatory == 1 && (
                        <strong 
                          style={{ 
                            marginLeft: '12px', 
                            fontSize: '11px', 
                            fontWeight: 'bold', 
                            padding: '2px 8px', 
                            borderRadius: '4px',
                            backgroundColor: personTickets.IsMRZScanned == 1 ? '#2ecc71' : '#e74c3c',
                            color: 'white',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px'
                          }}
                        >
                          MRZ
                        </strong>
                      )}
                    </div>
                    <div className="col-md-1 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {translations[lang]["Age/Cat Gender"]}:
                      </span>
                      {personTickets.AgeCategory}/{personTickets.Gender}
                    </div>
                    <div className="col-md-1 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {translations[lang]["Nationality"]}:
                      </span>
                      {personTickets.Nationality}
                    </div>
                    <div className="col-md-2 col-xs-4 resultTick">
                      <span title={personTickets.BoardID} className="rowdescr">
                        {translations[lang]["Birth Date"]}/{translations[lang]["Birth Place"]}:
                      </span>
                      {personTickets.BirthDate.substr(-2) +
                        "/" +
                        personTickets.BirthDate.substr(-4, 2) +
                        "/" +
                        personTickets.BirthDate.substr(0, 4)}{" "}
                      - {personTickets.BirthPlace}
                    </div>

                    <div className="col-md-1 col-xs-4 resultTick">
                      {personTickets.BoardStatus === "N" ? (
                        <span>New</span>
                      ) : null}
                      {personTickets.BoardStatus === "A" ? (
                        <span>Printed</span>
                      ) : null}
                      {personTickets.BoardStatus === "C" ? (
                        <span>Cancelled</span>
                      ) : null}
                      {personTickets.BoardStatus === "S" ? (
                        <span>Boarded</span>
                      ) : null}
                    </div>
                    <div className="col-md-12 inputprops" >
                      <div className="col-md-6 leftStay">
                        {personTickets.ConfirmationStatus !== "Canceled" ? (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Email Address"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              value={this.props.ticketEmails[index]}
                              name="ticketEmail"
                              type="text"
                              maxLength={50}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketEmail(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Email Address"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              disabled
                              value={this.props.ticketEmails[index]}
                              name="ticketEmail"
                              type="text"
                              maxLength={50}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketEmail(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        )}
                      </div>
                      <div className="col-md-6">
                        {personTickets.ConfirmationStatus !== "Canceled" ? (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Phone Number"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              value={this.props.ticketPhoneNumbers[index]}
                              name="ticketPhone"
                              type="text"
                              maxLength={20}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketPhone(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Phone Number"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              disabled
                              value={this.props.ticketPhoneNumbers[index]}
                              name="ticketPhone"
                              type="text"
                              maxLength={20}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketPhone(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
              {this.props.vehicleTickets.length > 0 && (
                <div className="col-md-12 head ticketOptions HeadTicks">
                  <div className="col-md-1 selectCol" />
                  <div className="col-md-2">
                    {translations[lang]["Ticket Number"]}
                  </div>
                  <div className="col-md-1">
                    {"Board ID"}
                  </div>
                  <div className="col-md-3">
                    {translations[lang]["Driver Name"]}
                  </div>
                  <div className="col-md-2">{translations[lang]["Plates"]}</div>
                  <div className="col-md-1">
                    {translations[lang]["Vehicle Type"]}
                  </div>
                  <div className="col-md-1">
                    {translations[lang]["Length/Height"]}
                  </div>
                  <div className="col-md-1">{translations[lang]["Status"]}</div>
                </div>
              )}
              {this.props.vehicleTickets.map((vehicleTickets, index) => {
                return (
                  <div
                    className="col-md-12 col-xs-12 resultsRTicks"
                    title={vehicleTickets.BoardID}
                    key={vehicleTickets.BookID}
                  >
                    <div className="col-md-1 col-xs-1 selectCol">
                      <Checkbox
                        color="primary"
                        checked={this.props.selectedVehicleTickets[index]}
                        onClick={() => {
                          this.props.handleVehicleCheckboxChange(index);
                        }}
                      />
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-2 col-xs-3 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {translations[lang]["Ticket Number"]}:{" "}
                      </span>
                      {vehicleTickets.TicketNumber}
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-1 col-xs-3 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {"Board ID"}:{" "}
                      </span>
                      {vehicleTickets.BoardID === "0" ? ("-") : (vehicleTickets.BoardID)}
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-3 col-xs-4 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {translations[lang]["Driver Name"]}:{" "}
                      </span>
                      {vehicleTickets.DriverName}
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-2 col-xs-3 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {translations[lang]["Plates"]}:{" "}
                      </span>
                      {vehicleTickets.RegistrationNumber}
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-1 col-xs-4 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {translations[lang]["Vehicle Type"]}:{" "}
                      </span>
                      {vehicleTickets.VehicleType}
                    </div>
                    <div
                      title={vehicleTickets.BoardID}
                      className="col-md-1 col-xs-4 resultTick"
                    >
                      <span title={vehicleTickets.BoardID} className="rowdescr">
                        {translations[lang]["Length/Height"]}:{" "}
                      </span>
                      {vehicleTickets.Length}/{vehicleTickets.Height}
                    </div>
                    <div className="col-md-1 col-xs-4 resultTick">
                      {vehicleTickets.BoardStatus === "N" ? (
                        <span>New</span>
                      ) : null}
                      {vehicleTickets.BoardStatus === "A" ? (
                        <span>Printed</span>
                      ) : null}
                      {vehicleTickets.BoardStatus === "C" ? (
                        <span>Cancelled</span>
                      ) : null}
                      {vehicleTickets.BoardStatus === "S" ? (
                        <span>Boarded</span>
                      ) : null}
                    </div>
                    <div className="col-md-12 inputprops">
                      <div className="col-md-6 leftStay">
                        {vehicleTickets.ConfirmationStatus !== "Canceled" ? (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Email Address"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              value={this.props.ticketVehicleEmails[index]}
                              name="ticketEmail"
                              type="text"
                              maxLength={50}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketVehicleEmail(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Email Address"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              disabled
                              value={this.props.ticketVehicleEmails[index]}
                              name="ticketEmail"
                              type="text"
                              maxLength={50}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketVehicleEmail(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        )}
                      </div>
                      <div className="col-md-6">
                        {vehicleTickets.ConfirmationStatus !== "Canceled" ? (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Phone Number"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              value={
                                this.props.ticketVehiclePhoneNumbers[index]
                              }
                              name="ticketPhone"
                              type="text"
                              maxLength={20}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketVehiclePhone(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        ) : (
                          <FormGroup bsSize="large" className="left">
                            <ControlLabel>
                              {translations[this.props.lang]["Phone Number"]}
                            </ControlLabel>
                            <FormControl
                              className="well"
                              disabled
                              value={
                                this.props.ticketVehiclePhoneNumbers[index]
                              }
                              name="ticketPhone"
                              type="text"
                              maxLength={20}
                              onChange={event => {
                                this.props.handleChangeOfInputTicketVehiclePhone(
                                  event,
                                  index
                                );
                              }}
                            />
                          </FormGroup>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </Col>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReservationDetails.js